'use client';

import useSWR from 'swr';
import { useUser } from '@mentimeter/user';
import { useEntitlementsContext } from './EntitlementsContext';
import { getClientEntitlements } from './get-client-entitlements';

export function useEntitlementsQuery() {
  const { isAuthenticated } = useUser();
  const fallbackEntitlements = useEntitlementsContext();

  const {
    data: entitlements,
    error,
    isLoading,
  } = useSWR(
    isAuthenticated ? 'entitlements' : undefined,
    getClientEntitlements,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      // If we have data from the server already, we don't need to refetch it on mount
      revalidateOnMount: !fallbackEntitlements,
      ...(fallbackEntitlements ? { fallbackData: fallbackEntitlements } : {}),
    },
  );

  return {
    entitlements,
    error,
    isLoading,
  };
}

export function useEntitlements() {
  const entitlements = useEntitlementsContext();

  if (!entitlements) {
    throw new Error(
      'Entitlements not found, this page/component must be wrapped with an <EntitlementsProvider> or <EntitlementsTestProvider> that provides necessary entitlement(s)',
    );
  }

  return entitlements;
}
